import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { StudentInternshipDetailsModel } from 'common/models/page-models/student-side/internship-detail/student-internship-detail-data.model';
import { FormResolverService } from 'common/resolvers/core-resolvers/form-resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { StudentInternshipDetailWidgetService } from 'common/widget/student-side/student-internship/student-internship-detail.service';

@Injectable({
  providedIn: 'root',
})
export class StudentInternshipDetailsResolver extends FormResolverService<StudentInternshipDetailsModel> {
  constructor(
    protected fs: StudentInternshipDetailWidgetService,
    protected override router: Router,
    protected override systemService: SystemService
  ) {
    super(fs, router, systemService);
  }

  override modifyResponseData(dataModel) {
    dataModel['yescheck'] = '';
    dataModel['nocheck'] = '';
    dataModel['anotherInternshipYes'] = '';
    dataModel['anotherInternshipNo'] = '';
    dataModel['studentjoinedinternshipyes'] = '';
    dataModel['studentjoinedinternshipno'] = '';
    dataModel['isInternshipcompleted'] = '';
    dataModel['isInternshipnotcompleted'] = '';
  //  dataModel['tabNumber']='';
    
    //  dataModel.studentFeedback.forEach((question) => {
    //   dataModel[question.id] = question.answer;
      
    // });
   
    return dataModel;
  }

}
